module.exports = __webpack_public_path__ + "static/media/arrow-down.a263533a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/arrow-down.svg
// module id = 2917
// module chunks = 0